import { ChipMetadata } from '@pmi/dsm-react';
import {
  ArticleNewsIcon,
  CertificationIcon,
  GroupIcon,
  LevelIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import FilledIcon from '@pmi/dsm-react/dist/components/icons/16/bookmark/FilledIcon';
import { CategoryType } from './models';
import { ProductTypes } from '../../constants';

interface CategoryLabelProps {
  type: CategoryType;
  className: string;
}

export default function CategoryLabel({ type, className }: CategoryLabelProps) {
  switch (type) {
    case 'Certification':
      return (
        <ChipMetadata
          text="Certification"
          className={`${className} text-uppercase`}
          icon={<CertificationIcon />}
          variant="red"
        />
      );
    case 'Digital Product':
      return (
        <ChipMetadata
          text="Digital Product"
          className={`${className} text-uppercase`}
          icon={<ArticleNewsIcon />}
          variant="green"
        />
      );
    case 'eLearning':
      return (
        <ChipMetadata
          text="Online Course"
          className={`${className} text-uppercase`}
          icon={<FilledIcon />}
          variant="aqua"
        />
      );
    case ProductTypes.membership:
    case 'Chapter Membership':
      return (
        <ChipMetadata
          text="Membership"
          className={`${className} text-uppercase`}
          icon={<GroupIcon />}
          variant="violet"
        />
      );
    case 'Bundle':
      return (
        <ChipMetadata
          text="Bundle"
          className={`${className} text-uppercase`}
          icon={<LevelIcon />}
          variant="tangerine"
        />
      );

    default:
      return null;
  }
}
